import { render } from "./Reminders.vue?vue&type=template&id=08f3527c&scoped=true"
import script from "./Reminders.vue?vue&type=script&lang=js"
export * from "./Reminders.vue?vue&type=script&lang=js"

import "./Reminders.vue?vue&type=style&index=0&id=08f3527c&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f3527c"]])

export default __exports__